module.exports = __webpack_public_path__ + "static/img/case_detail_02_3_h5.88a308e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_detail_02_3_h5.png
// module id = hqwo
// module chunks = 34